module.exports = __webpack_public_path__ + "static/blog58-3f31bb9c6ea6339844dcc4d5e70631d7.png";